export const scrollHandle = 'scrollHandle'
export const resizeHandle = 'resizeHandle'
// 点击导航条跳转事件
export const beautyScroll = 'beautyScroll'
export const newbornScroll = 'newbornScroll'
